
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[code]",
      function () {
        return require("private-next-pages/articles/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[code]"])
      });
    }
  